import type {
    NewOutlookSpace,
    NewOutlookSpaceAsset,
    OutlookSpaceId,
    OutlookSpacesFilter,
    PatchOutlookSpace,
    PatchOutlookSpaceAsset,
} from 'owa-timestream-types';
import getDefaultOutlookSpacesService from './getDefaultOutlookSpacesService';

// NOTE: functions from this file are being deprecated since they do not take into
// consideration that projects can live in different mailboxes. New code should
// be using the owa-timestream-store service function, which take the ProjectId
// and figure out where the project lives (ex: user or group mailbox).

//
// Outlook Spaces (Collection)
//
export function getOutlookSpaces(spacesFilter?: OutlookSpacesFilter) {
    return getDefaultOutlookSpacesService().getOutlookSpaces(spacesFilter);
}

export function createOutlookSpace(newOutlookSpace: NewOutlookSpace) {
    if (newOutlookSpace.assets) {
        newOutlookSpace.assets.forEach(function (asset) {
            roundIntegers(asset);
        });
    }
    return getDefaultOutlookSpacesService().createOutlookSpace(newOutlookSpace);
}

//
// Outlook Space (Entity)
//
export function patchOutlookSpace(outlookSpaceId: OutlookSpaceId, changes: PatchOutlookSpace) {
    return getDefaultOutlookSpacesService().patchOutlookSpace(outlookSpaceId, changes);
}

//
// Outlook Space Assets (Collection)
//
export function getOutlookSpaceAssets(outlookSpaceId: OutlookSpaceId) {
    return getDefaultOutlookSpacesService().getOutlookSpaceAssets(outlookSpaceId);
}

export function createOutlookSpaceAsset(
    outlookSpaceId: OutlookSpaceId,
    newAsset: NewOutlookSpaceAsset
) {
    return getDefaultOutlookSpacesService().createOutlookSpaceAsset(
        outlookSpaceId,
        roundIntegers(newAsset)
    );
}

//
// Recycle Bin
//
export function emptyOutlookSpaceRecycleBin(outlookSpaceId: OutlookSpaceId) {
    return getDefaultOutlookSpacesService().emptyOutlookSpaceRecycleBin(outlookSpaceId);
}

function roundIntegers<T extends PatchOutlookSpaceAsset>(p: T): T {
    p.x = roundInteger(p.x);
    p.y = roundInteger(p.y);
    p.width = roundInteger(p.width);
    p.height = roundInteger(p.height);
    p.rotation = roundInteger(p.rotation);
    return p;
}

function roundInteger(value: number | undefined): number | undefined {
    return !!value ? Math.round(value) : value;
}
